import React, { useMemo } from "react";
import {
  useTable,
  useBlockLayout,
  useResizeColumns,
  useSortBy,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import styled from "styled-components";
import CsvDownloader from "react-csv-downloader";
import { Styles, color } from "./SCPChartHelpers";
import "./css/AiTable.css";
import { GlobalFilter } from "./GlobalFilter";
import { ColumnFilter } from "./ColumnFilter";
import { FaArrowDownShortWide } from "react-icons/fa6";
import { FaArrowDownWideShort } from "react-icons/fa6";

export function Table({ columns, data }) {
  //alert(JSON.stringify(data));
  //alert(JSON.stringify(columns));
  const csvData = [
    ["firstname", "lastname", "email"],
    ["John", "Doe", "john.doe@xyz.com"],
    ["Jane", "Doe", "jane.doe@xyz.com"],
  ];
  const defaultColumn = React.useMemo(
    () => ({
      Filter: ColumnFilter,
      minWidth: 30,
      width: 150,
      maxWidth: 400,
    }),
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    rows,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    resetResizing,
  } = useTable(
    {
      columns: columns,
      data: data,
      defaultColumn,
      initialState: { pageIndex: 0 },
    },
    useBlockLayout,
    useResizeColumns,
    useSortBy,
    useFilters,
    useGlobalFilter,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;
  return (
    <>
      <span>
        <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />{" "}
        <button className="column-resize" onClick={resetResizing}>
          Reset Column Resizing
        </button>
      </span>
      <CsvDownloader
        columns={columns}
        datas={data}
        text="Export CSV"
        filename={"AI_result_table" + new Date().toLocaleString()}
        extension=".csv"
      />
      <table className="table" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} className="tr">
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="th"
                >
                  {column.render("Header")}

                  {/* Use column.getResizerProps to hook up the events correctly */}
                  <div
                    {...column.getResizerProps()}
                    className={`resizer ${
                      column.isResizing ? "isResizing" : ""
                    }`}
                  />
                  <span>
                    {"  "}
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <FaArrowDownWideShort />
                      ) : (
                        <FaArrowDownShortWide />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="tr">
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} className="td">
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="table-global-filter">
        <span>
          <span>
            Go to page:{" "}
            <input
              className="goto-page"
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const pageNumber = e.target.value
                  ? Number(e.target.value) - 1
                  : 0;
                gotoPage(pageNumber);
              }}
              style={{ width: "50px" }}
            />
          </span>
          {"  "}
          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 25, 50].map((pageSize) => (
              <option className="page-size" key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          {"  "}
          <button
            className="page-button"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            {"<<"}
          </button>{" "}
          <button
            className="page-button"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Previous
          </button>{" "}
          <button
            className="page-button"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            Next
          </button>{" "}
          <button
            className="page-button"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </button>
          <span className="page-number">
            Page{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{" "}
          </span>
        </span>
      </div>
    </>
  );
}
export const SCPTable = ({ COLUMNS, inputData, title }) => {
  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => inputData, []);

  return (
    <div>
      <div className="chartTitle">{title}</div>
      <Styles>
        <Table columns={columns} data={data} />
      </Styles>
    </div>
  );
};
